export default "__VITE_ASSET__DAAm5hcC__"